<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import utils from './assets/utils'
import WebFont from 'webfontloader'

export default {
  name: 'App',
  created () {
    let webFontConfig = {
      custom: {
        families: ['sequelsans-lightbody'] // array of fonts where we want to check if loaded
      },
      fontactive: function () {
        this.setFontLoaded(true)
      }.bind(this),
      fontinactive: function () {
        this.setFontLoaded(true)
      }.bind(this)
    }

    window.addEventListener('resize', this.handleResize, false)
    this.setBreakpoint(utils.checkBreakpoint())

    // checks when custom font is loaded
    // if you need to have some sort of action when a font is loaded
    WebFont.load(webFontConfig)
  },
  computed: {
    ...mapState([
      'breakpoint'
    ])
  },
  methods: {
    ...mapMutations([
      'setBreakpoint',
      'setFontLoaded'
    ]),
    /**
     * Sets the current breakpoint.
     */
    handleResize () {
      let bp = utils.checkBreakpoint()
      if (bp !== this.breakpoint) {
        this.setBreakpoint(bp)
      }
    }
  }
}
</script>

<style lang="sass">
@import './assets/scss/_globals.scss'
@import './assets/scss/App.scss'
</style>
